<template>
  <section class="statusbar">
    <select v-if="resources" @change="refresh" v-model="slopeId"  name="slopes" class="slopes">
        <option v-for="resource in resources" :key="resource.id" :value="resource.id">{{resource.name}}</option>
    </select>
    <div class="date">{{date}}</div>
    
    <img @click="refresh" class="refresh-icon"
          src="../assets/Refresh.svg"
          alt="Refresh" />

  </section>
</template>

<script>
    import { useStore } from 'vuex'

    export default {
        name: 'Statusbar',
        props:['slopeId','resources','date'],
        setup(props) {
            const store = useStore()
            const refresh = async () => {
                try {
                    await store.dispatch('refresh', props.slopeId)
                } catch (err) {
                    console.log(err)
                }
            }
            
            return {refresh}
        }
    }
</script>

<style scoped>
.statusbar {
  display: flex;
  justify-content: space-between;
  background: #ddd;
  align-items: center;
  height: 60px;
}
.statusbar .slope {
  /* background: yellow; */
  min-width: 250px;
}
.statusbar .date {
  /* background: green; */
  min-width: 100px;
  font-size: 14px;
}
.slopes {
  /* min-width: 150px; */
  padding: 0 15px;
  margin: 10px;
  width: 160px;
  height: 40px;
  border: none;
  background: crimson;
  border-radius: 20px;
  color: white;
  outline: none;
  font-size: 16px;
  font-weight: bold;
}
.refresh-icon {
  width: 30px;
  height: 30px;
  margin: 0px 15px;
}
</style>